module.exports = __webpack_public_path__ + "img/02.ca2e24a1.jpg";